"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customDayCell = ({ dataItem, dataIndex, columnIndex }) => {
    const today = new Date().getDate();
    const rowColor = [6, 10, 14, 15].includes(dataIndex + 1);
    const columnColor = columnIndex && columnIndex + 1 === (today + 5);
    const isMinus = dataItem[`date_${columnIndex && columnIndex - 4}`] < 0;
    const isDayOff = columnIndex && columnIndex + 1 === (dataItem.is_dayoff + 5);
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${dataIndex}`, style: {
            color: isMinus ? '#BA352C' : rowColor || columnColor || isDayOff ? '#FFFFFF' : 'inherit',
            textDecoration: isMinus ? 'underline' : 'none',
            backgroundColor: isDayOff ? '#BA352C'
                : columnColor ? '#4C8C8C'
                    : isMinus ? '#FFC700'
                        : rowColor ? '#727272' : 'inherit'
        } }, { children: dataItem[`date_${columnIndex && columnIndex - 4}`] })));
};
exports.default = customDayCell;
